module.exports = __webpack_public_path__ + "img/card1hover.5367592b.svg";